import { render, staticRenderFns } from "./overDue.vue?vue&type=template&id=2f6c7dc2&"
import script from "./overDue.vue?vue&type=script&lang=js&"
export * from "./overDue.vue?vue&type=script&lang=js&"
import style0 from "./overDue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports